import { PlanLimitExceededSource } from "store/entities/subscriptions";

import { ISubscriptionViewState } from "./reducer";

export interface IWithSubscriptionViewState {
  views: {
    subscription: ISubscriptionViewState;
  };
}

export function selectFocusedColumn(state: IWithSubscriptionViewState): number {
  return state.views.subscription.focusedColumn;
}

export const selectUpsellModalOpened = (state: IWithSubscriptionViewState): boolean => {
  return state.views.subscription.upsellModal.open;
};

export const selectUpsellModalSource = (state: IWithSubscriptionViewState): PlanLimitExceededSource | null => {
  return state.views.subscription.upsellModal.source;
};
